import {Component, Inject} from '@angular/core';
import {FormBuilder, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {BlobService} from "../../../../core/base/blob.service";

@Component({
    selector: 'app-new-container',
    templateUrl: './new-container.component.html',
    styleUrl: './new-container.component.scss',
    standalone: false
})
export class NewContainerComponent {

  folderForm = this.formBuilder.group({
    folderName: ['', [Validators.required, Validators.pattern('^[a-z0-9]*$')]]
  })
  constructor(private formBuilder: FormBuilder,
              public dialogRef: MatDialogRef<NewContainerComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private blobService: BlobService) {

  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  create() {
    const folderName = this.folderForm.value;

    let newFolder = folderName.folderName ? folderName.folderName : '';

    const ret = this.blobService.createContainer(newFolder, {modified_by: this.getUserDetails(this.data.user)});

    ret.then((r: any) => {
      this.dialogRef.close({error: r.error_code, filename: newFolder.trim()});
    });
  }

  private getUserDetails(user: any) {
    return user.name + ' (' + user.username + ')'
  }
}
